import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IvLiveComponent } from './core/components/ivlive/ivlive.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/app',
    pathMatch: 'full'
  },
  {
    path: 'app',
    component: IvLiveComponent
  },
  {
    path: 'page',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'oic',
    loadChildren: () => import('./pages/oic/oic.module').then(m => m.OICModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
